export default {
  callCenter: {
    signIn: 'Sign In',
    signOut: 'Sign Out',
    setIdle: 'Set to Idle',
    setBusy: 'Set to Busy',
    hangup: 'End Call',
    monitor: 'Monitor',
    signInSuccess: 'Signed in successfully',
    signOutSuccess: 'Signed out successfully',
    setIdleSuccess: 'Set to idle successfully',
    setBusySuccess: 'Set to busy successfully',
    notSignedIn: 'Not signed in',
    idle: 'Idle',
    busy: 'Busy',
    all: 'All',
    callDuration: 'Call Duration',
    todayCallCount: 'Calls Today',
    beginCallout: 'Start Outbound Calls',
    endCallout: 'End Outbound Calls',
    addBinding: '+ Add Binding',
    operation: 'Actions',
    unbind: 'Unbind',
    unbindConfirm: 'Confirm Unbind',
    unbindConfirmText: 'Unbinding will remove the association between the extension and the Learning Center. After unbinding, the Learning Center will no longer be able to use this feature. Continue?',
    addBindTitle: 'Add Binding',
    campusId: 'Learning Center ID',
    pleaseEnterCampusId: 'Enter Learning Center ID',
    trafficSystem: 'Telephony System',
    pleaseSelectTrafficSystem: 'Select Telephony System',
    hantianSystem: 'Hantian Telephony System',
    yixunSystem: 'Yixun Telephony System',
    extNo: 'Extension Number',
    agentNo: 'Agent ID',
    pleaseEnterExtNo: 'Enter Extension Number',
    pleaseEnterAgentNo: 'Enter Agent ID',
    outboundDisplayPhone: 'Outbound Caller ID',
    pleaseEnterOutboundPhone: 'Enter outbound caller ID',
    outboundPhoneTip: 'Note: Caller ID currently supports mobile numbers only',
    addExtSeat: '+ Add Extension & Agent',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm',
    campusName: 'Learning Center Name',
    bindUser: 'Operator',
    bindTime: 'Operation Time',
    unbindSuccess: 'Unbound successfully',
    unbindFail: 'Failed to unbind',
    pleaseEnterCampusIdErr: 'Enter Learning Center ID',
    pleaseSelectTrafficSystemErr: 'Select Telephony System',
    pleaseEnterExtNoErr: 'Enter Extension Number',
    pleaseEnterAgentNoErr: 'Enter Agent ID',
    operationSuccess: 'Operation successful',
    operationFail: 'Operation failed',
    campus: 'Learning Center',
    pleaseEnterExtNoPlaceholder: 'Enter Extension Number',
    pleaseEnterAgentNoPlaceholder: 'Enter Agent ID',
    workbenchTitle: 'Outbound Call Workspace',
    realPhone: 'Actual Phone Number:',
    displayPhone: 'Displayed Caller ID:',
    callNow: 'Call Now',
    endCall: 'End Call',
    followPerson: 'Follow-up Owner:',
    followInfo: 'Follow-up Details:',
    more: 'More',
    noFollowYet: 'No follow-up yet',
    cluePhone: 'Lead Phone:',
    clueSource: 'Lead Source:',
    studentName: 'Student Name',
    grade: 'Grade',
    familyMember1: 'Family Member 1',
    familyMember2: 'Family Member 2',
    pleaseFill: 'Please fill in',
    pleaseSelect: 'Please select',
    queryTimeRange: 'Time Range',
    belongToAgent: 'Assigned Agent',
    callDurationRankQueryTime: 'Time Range',
    callDurationRankCustomerService: 'Assigned Agent',
    callDurationRankNamePlaceholder: 'Name',
    callDurationRankCallType: 'Call Type',
    callTime: 'Call Time',
    recordDuration: 'Recording Duration',
    statusPlaceholder: 'Status',
    callDurationRankAgentName: 'Agent Name',
    agentStatus: 'Agent Status',
    todayFirstSignInTime: 'First Sign-in Today',
    lastCallTime: 'Last Call Time',
    todayConnectedCount: 'Connected Calls Today',
    todayTotalCallDuration: 'Total Call Duration Today',
    callDurationRankFirstCall: 'First Call',
    callDurationRankLastCall: 'Last Call',
    callDurationRankCallCount: 'Total Calls',
    callDurationRankConnectedCount: 'Connected Calls',
    callDurationRankEffectiveConnectedCount: 'Effective Connections',
    callDurationRankConnectedRate: 'Connection Rate',
    callDurationRankCallDuration: 'Call Duration',
    callDurationRankTotalCallDuration: 'Total Call Duration',
    callDurationRankAverageCallDuration: 'Average Call Duration',
    callDurationRankType: 'Type',
    callDurationRankBelongCampus: 'Learning Center',
    today: 'Today',
    last7Days: 'Last 7 Days',
    last30Days: 'Last 30 Days',
    inbound: 'Inbound',
    outbound: 'Outbound',
    callerNo: 'Caller Number',
    calleeNo: 'Callee Number',
    pleaseEnterCallerNo: 'Enter caller number',
    pleaseEnterCalleeNo: 'Enter callee number',
    record0_15: '0–15 sec',
    record15_30: '15–30 sec',
    record30_60: '30–60 sec',
    record60_180: '1–3 min',
    record180_300: '3–5 min',
    record300_600: '5–10 min',
    record600Plus: '10+ min',
    phonePlaceholder: 'Phone Number',
    gradeEditOnce: 'Grade can only be updated once',
    studentGender: 'Student Gender',
    school: 'School',
    birthday: 'Date of Birth',
    homeAddress: 'Home Address',
    intentLevel: 'Interest Level',
    tag: 'Tag',
    remark: 'Notes',
    followStatus: 'Follow-up Status',
    nextFollowTime: 'Next Follow-up Time',
    pleaseSelectFollowStatus: 'Select follow-up status',
    promiseVisitTime: 'Scheduled Visit Time:',
    visitTime: 'Visit Time:',
    selectPromiseVisitTime: 'Select scheduled visit time',
    selectVisitTime: 'Select visit time',
    visitStore: 'Visited Location:',
    pleaseSelectVisitStore: 'Select visited location',
    followDesc: 'Follow-up Notes:',
    transferClue: 'Transfer Lead',
    saveRecord: 'Save Record',
    saveSuccess: 'Saved successfully',
    saveFail: 'Save failed',
    stageK1: 'Pre-K Small',
    stageK2: 'Pre-K Medium',
    stageK3: 'Pre-K Large',
    grade1: 'Grade 1',
    grade2: 'Grade 2',
    grade3: 'Grade 3',
    grade4: 'Grade 4',
    grade5: 'Grade 5',
    grade6: 'Grade 6',
    grade7: 'Grade 7',
    grade8: 'Grade 8',
    grade9: 'Grade 9',
    gradeH1: 'Grade 10',
    gradeH2: 'Grade 11',
    gradeH3: 'Grade 12',
    gradeH4: 'Others',
    gradeCommon: 'General',
    followPhone: 'Called',
    followWechat: 'Added on WeChat',
    followPromise: 'Visit Scheduled',
    followVisit: 'Visited',
    followInvalid: 'Inactive',
    followDeal: 'Closed Deal',
    callMakecall: 'Initiate Call',
    callOutcall: 'Agent Connected',
    callOutringing: 'Agent Ringing',
    callConnecting: 'Connecting',
    callAfter: 'Call Ended',
    callAgentidle: 'Agent Idle',
    callCalling: 'Dialing',
    callPlaytts: 'Playing Agent ID',
    callIncall: 'Agent Answered',
    callAnswer: 'In Call',
    totalCallDuration: 'Total Call Duration',
    totalCallCount: 'Total Call Count',
    successRate: 'Connection Rate',
    effectiveVsTotal: 'Effective / Total',
    avgCallDurationLabel: 'Average Call Duration',
    minutesUnit: 'min',
    addCallButton: 'Add Call',
    showOnlyUnanswered: 'Show Unanswered Only',
    callerColumn: 'Caller',
    callTypeColumn: 'Call Type',
    leadNameColumn: 'Lead Name',
    leadPhoneColumn: 'Lead Phone',
    callTimeColumn: 'Call Time',
    phoneStatusColumn: 'Phone Status',
    callDurationColumn: 'Call Duration',
    callRecordingColumn: 'Call Recording',
    playText: 'Play',
    downloadText: 'Download',
    viewFollowRecord: 'View Follow-up Records',
    newCallInputLabel: 'Enter phone number to call',
    newCallInputPlaceholder: 'Enter phone number',
    redialTooltip: 'Redial',
    recordingDialogTitle: 'Call Recording',
    recordingCallerLabel: 'Caller:',
    cancelOrderConfirmText: 'Are you sure you want to cancel this order? Paid amounts will be refunded to the corresponding Master Franchisee account and quotas will be adjusted.',
    payDeductTip: 'This payment will deduct:',
    unopenedTitle: 'Outbound Calling Not Activated',
    unopenedMessage: 'Dear Franchisee, your outbound calling service is not activated. Click "Activate Now" to enable or renew.',
    thinkAgain: 'Cancel',
    goToOpen: 'Activate Now',
    overdueTitle: 'Outbound Calling Overdue',
    overdueMessage: 'Dear Franchisee, your outbound calling service has exceeded the usage limit. Click "Recharge Now" to continue.',
    goToRecharge: 'Recharge Now',
    paySuccessResult: 'Payment of {symbol}{money}{unitSuffix} successful',
    payFailResult: 'Payment of {symbol}{money}{unitSuffix} failed',
    iKnow: 'Got it',
    male: 'Male',
    female: 'Female',
    indicatorTipIntro: 'Based on your selected filters such as time range, call duration, follow-up status, phone status, caller, and lead filters',
    totalCallDurationFormula: 'Total Call Duration = Sum of call durations under current filters',
    totalCallCountFormula: 'Total Call Count = Number of calls under current filters',
    successRateFormula: 'Connection Rate = Connected calls / Total calls × 100%',
    effectiveEfficiencyFormula: 'Effective Efficiency = Average daily connected calls per agent',
    totalEfficiencyFormula: 'Total Efficiency = Average daily total calls per agent',
    avgCallDurationFormula: 'Average Call Duration = Average call duration under current filters',
    presalePrice: 'Pre-sale Price',
    originalPrice: 'Original Price $60',
    providerTip: 'Provided by the same vendor as Zuoyebang and Yuanfudao',
    providerTipPrefix: '*Outbound calling technology provided by',
    operatorTip: '*Covers all major carriers nationwide',
    localNumberTip: 'No need to prepare phone numbers',
    localNumberTipPrefix: '*System automatically assigns local numbers,',
    markTip: 'Prevents number tagging and blocking',
    markTipPrefix: '*Helps',
    newOpenTip: '*New activation',
    newOpenTipSuffix: 'requires a setup fee; renewals do not require this fee',
    monthlyTipPrefix: '*Billed monthly,',
    monthlyTip: 'unlimited users',
    openFeeLabel: 'Setup Fee:',
    openFeeDiscount: 'Limited-time 90% off, original price $43.00',
    packageFeeLabel: 'Package Fee:',
    packageFeeDetail: 'Unlimited users, includes 500 free minutes, additional $0.12/min',
    openMonthsLabel: 'Number of Months:',
    monthUnit: 'month(s)',
    presaleMaxMonths: 'Maximum 12 months for pre-sale',
    payTipPrefix: 'Before payment, please read and agree to the',
    agreementLinkText: 'Service Agreement',
    totalLabel: 'Total:',
    yuanUnit: '$',
    validityMonths: '/Valid for {months} months',
    payCancel: 'Cancel',
    payConfirm: 'Pay',
    voucherAccount: 'Bonus Account',
    cashAccount: 'Cash Account',
    goldAccount: 'Gold Account',
    deliveryAccount: 'Delivery Voucher Account',
    accountYuan: '{amount}',
  },
}
